module.exports = __webpack_public_path__ + "static/media/checkko.34c4dc02.svg";